import { IHttpResponse, IProviderEntity } from '@gr/shared/models';
import useAxios, { UseAxiosResult } from 'axios-hooks';

export default function useProviders(): UseAxiosResult<IHttpResponse<IProviderEntity[]>> {
  return useAxios<IHttpResponse<IProviderEntity[]>>({
    url: 'providers-get',
    method: 'POST',
  });
}
